import { InputText } from "primereact/inputtext";
import { FC } from "react";
import Form from "react-bootstrap/Form";
import CommonFormLabel from "./CommonFormLabel";
import { isFieldRequired } from "../../helpers/utils";
interface IThemeInputSearch {
  controlId: string;
  label?: string;
  placeholder?: string;
  handleChange?: any;
  handleBlur?: any;
  errorsField?: any;
  touched?: any;
  value?: any;
  inputClassName?: any;
  inputWrapClass?: any;
  wrapperClassname?: any;
  validationSchema?: any;
  tooltip?: any;
  tooltipContent?: any;
}

/**
 * Input Search Reusable Component
 *
 * @param {{ controlId: any; label: any; placeholder: any; handleChange: any; handleBlur: any; errorsField: any; touched: any; value: any; inputClassName: any; inputWrapClass: any; wrapperClassname: any; validationSchema: any; tooltip: any; tooltipContent: any; }} param0
 * @param {*} param0.controlId
 * @param {*} param0.label
 * @param {*} param0.placeholder
 * @param {*} param0.handleChange
 * @param {*} param0.handleBlur
 * @param {*} param0.errorsField
 * @param {*} param0.touched
 * @param {*} param0.value
 * @param {*} param0.inputClassName
 * @param {*} param0.inputWrapClass
 * @param {*} param0.wrapperClassname
 * @param {*} param0.validationSchema
 * @param {*} param0.tooltip
 * @param {*} param0.tooltipContent
 * @returns
 */

const ThemeInputSearch: FC<IThemeInputSearch> = ({
  controlId,
  label,
  placeholder,
  handleChange,
  handleBlur,
  errorsField,
  touched,
  value,
  inputClassName,
  inputWrapClass,
  wrapperClassname,
  validationSchema,
  tooltip,
  tooltipContent,
}) => {
  const isRequired = validationSchema
    ? isFieldRequired(validationSchema, controlId)
    : false;

  return (
    <Form.Group className={wrapperClassname}>
      {label && (
        <CommonFormLabel
          controlId={controlId}
          label={label}
          isRequired={isRequired}
          tooltip={tooltip}
          tooltipContent={tooltipContent}
        />
      )}
      <div
        className={`position-relative w-100 ${inputWrapClass ? inputWrapClass : ""}`}
      >
        <InputText
          id={controlId}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          className={
            errorsField && touched
              ? `p-invalid is-invalid w-100 p-inputtext-sm ${inputClassName ?? ""}`
              : `w-100 p-inputtext-sm ${inputClassName ?? ""}`
          }
          onBlur={handleBlur}
        />
      </div>
      <Form.Control.Feedback
        type="invalid"
        className={errorsField && touched ? "d-block" : "d-none"}
      >
        {errorsField}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default ThemeInputSearch;
